/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'chat-bubble': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g clip-path="url(#svgicon_chat-bubble_a)" _fill="#686a7a"><path pid="0" d="M5.998 22v-4h-2c-1.103 0-2-.897-2-2V4c0-1.104.897-2 2-2h16c1.103 0 2 .896 2 2v12c0 1.103-.897 2-2 2h-8.667l-5.333 4Zm-2-18v12h4v2l2.667-2h9.333V4h-16Z"/><path pid="1" d="M17.998 6h-12v2h12V6ZM17.998 9h-12v2h12V9ZM13.998 12h-8v2h8v-2Z"/></g><defs><clipPath id="svgicon_chat-bubble_a"><path pid="2" _fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs>'
  }
})
